var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 6.0001C2.3999 5.36358 2.65276 4.75313 3.10285 4.30304C3.55293 3.85295 4.16338 3.6001 4.7999 3.6001H13.1999C13.8364 3.6001 14.4469 3.85295 14.897 4.30304C15.347 4.75313 15.5999 5.36358 15.5999 6.0001V10.8001C15.5999 11.4366 15.347 12.0471 14.897 12.4972C14.4469 12.9472 13.8364 13.2001 13.1999 13.2001H10.7999L7.1999 16.8001V13.2001H4.7999C4.16338 13.2001 3.55293 12.9472 3.10285 12.4972C2.65276 12.0471 2.3999 11.4366 2.3999 10.8001V6.0001Z",
    fill: "#2A282E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 8.3999V10.7999C17.9999 12.0729 17.4942 13.2938 16.594 14.194C15.6939 15.0942 14.473 15.5999 13.1999 15.5999H11.7935L9.67432 17.7203C10.0103 17.8991 10.3931 17.9999 10.7999 17.9999H13.1999L16.7999 21.5999V17.9999H19.1999C19.8364 17.9999 20.4469 17.747 20.897 17.297C21.3471 16.8469 21.5999 16.2364 21.5999 15.5999V10.7999C21.5999 10.1634 21.3471 9.55293 20.897 9.10285C20.4469 8.65276 19.8364 8.3999 19.1999 8.3999H17.9999Z",
    fill: "#2A282E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.b2d8ac7d7e274995b9c4558701ebcf77.svg";
export { ForwardRef as ReactComponent };